import React, { useState } from "react";
import "./ForgotPassword.scss";
import logo from "../../../assets/images/MainLogo.png";
import TextInput from "../../../components/TextInput/TextInput";
import Buttons from "../../../components/Buttons/Buttons";
import Spinner from "../../../components/Spinner/Spinner";
import { UserForgotPassword } from "../../../utils/apiCalls/auth";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../utils/ToastContext";

const initialValues = {
  email: "",
};

const ForgotPassword = () => {
  const [sendEmail, setSendEmail] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { showToast } = useToast();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    setSendEmail({
      ...sendEmail,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validateFields = () => {
    let errObj = { ...initialValues };
    if (!sendEmail.email) {
      errObj.email = "This field is required";
    } else if (!/\S+@\S+\.\S+/.test(sendEmail.email)) {
      errObj.email = "Email is invalid";
    } else {
      errObj.email = "";
    }
    setErrors((prev) => ({ ...prev, ...errObj }));
    const data = Object.values(errObj).every((x) => x === "" || x === null);
    return data;
  };

  const handleForgotPassword = async () => {
    if (isLoading) return;
    setIsLoading(true);
    if (validateFields()) {
      const payload = {
        email: sendEmail.email,
      };
      try {
        const res = await UserForgotPassword(payload);
        const { statusCode, message } = res;
        if (statusCode === 200) {
          setIsLoading(false);
          sessionStorage.setItem("email", sendEmail.email);
          navigate("/verification-code");
        } else {
          setIsLoading(false);
          showToast(message, "error");
        }
      } catch (error) {
        setIsLoading(false);
        showToast(error?.message, "error");
      }
    } else {
      setIsLoading(false);
    }
  };

  return (
    <div className="fp">
      {isLoading && (
        <div className="loader-container">
          <div className="loader">
            <Spinner />
          </div>
        </div>
      )}
      <div className="fp_bcg">
        <div className="fp_container">
          <div className="fp_section">
            <div className="fp_section_logo">
              <img src={logo} alt="logo" />
            </div>
            <div className="fp_section_header">
              <h3>Forgot Password</h3>
              <p>
                Please enter your email below to send you a password reset code
              </p>
            </div>
            <div className="fp_section_inputs">
              <div className="fp_section_inputs_data">
                <TextInput
                  title={"Enter Email"}
                  type={"email"}
                  placeholder={"Your email@example.com"}
                  name="email"
                  value={sendEmail.email}
                  onChange={handleChange}
                  error={!!errors.email}
                  helperText={errors.email}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleForgotPassword();
                    }
                  }}
                />
              </div>
            </div>
            <div className="fp_section_buttons">
              <Buttons
                text={"Send Code"}
                variant="primary"
                onClick={handleForgotPassword}
                disabled={isLoading}
              />
            </div>
            <div className="fp_section_back">
              <button type="button" className="back-link" onClick={() => navigate("/")}>
                Back to Sign In
              </button>
            </div>
          </div>
        </div>
        <div className="fp_bcglayout"></div>
      </div>
    </div>
  );
};

export default ForgotPassword;
